import { useEffect, useState } from "react";
import { Output } from "valibot";

import { requestBackend } from "shared/request";

import { StarterQuestionsSchema } from "./schemas";

function useStarterQuestions(token: string) {
  const [starterQuestions, setStarterQuestions] = useState<
    Output<typeof StarterQuestionsSchema>
  >([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    requestBackend("/v1/botsonic/widget/starter-questions/all", {
      headers: {
        token,
      },
      schema: StarterQuestionsSchema,
    })
      .then(
        newStarterQuestions => setStarterQuestions(newStarterQuestions),
        err => {
          // eslint-disable-next-line no-console
          console.error(err);
        },
      )
      .finally(() => setLoading(false));
  }, [token]);

  return {
    starterQuestions,
    setStarterQuestions,
    loading,
    error,
  };
}

export default useStarterQuestions;
